import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import UserList from "./UserList";
import UserPreview from "./UserPreview";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';

class Users extends React.Component {
    render() {
        return (
            /* page content */
            <div id="user-page" className="right-col" role="main">
                <div className="page-title">
                    <h3>Uživatelé</h3>
                </div>
                <Switch>
                    <Route exact path="/users" component={() =>
                        <UserList
                            {...this.props}
                        />
                    }
                    />
                    <Route exact path="/users/preview/:id" component={() =>
                        <UserPreview
                            {...this.props}
                        />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));



/** WEBPACK FOOTER **
 ** ./src/containers/Users/index.js
 **/